import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	title: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	forYouTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	title: {
		defaultMessage: 'Your work',
		id: 'home.header.title',
		description: 'Page title for the "Jira Home" / "Your work" page.',
	},
	forYouTitle: {
		defaultMessage: 'For you',
		id: 'home.header.forYou',
		description: 'Page title for the "Jira Home" / "For You" page.',
	},
});
export default messages;
